import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { PVModalDialog } from '../Shared/ContentContainers/PVModals';
import { createHTMLText } from '../../helpers/textFunctions';

function PVQuantityChangedModal({ title, message, onRequestClose, isOpen }) {
    const location = useLocation();
    const history = useHistory();

    const currentlyAtCart = location && location.pathname && location.pathname === '/Shop/Cart';
    const closeButton = (
        <button type="button" onClick={onRequestClose} className="pv btn btn-primary">
            {currentlyAtCart ? 'Close' : 'Continue Shopping'}
        </button>
    );
    const cartButton = (
        <button
            type="button"
            className="pv btn btn-primary"
            onClick={() => {
                history.push('/Shop/Cart');
            }}
        >
            Go to Cart
        </button>
    );

    // eslint-disable-next-line react/no-danger
    const body = <div dangerouslySetInnerHTML={createHTMLText(message)} />;
    return (
        <PVModalDialog
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            headerContent={title}
            bodyContent={body}
            footerContent={
                currentlyAtCart ? (
                    <span className="pull-right">{closeButton}</span>
                ) : (
                    <React.Fragment>
                        <span className="pull-left">{closeButton}</span>
                        <span className="pull-right">{cartButton}</span>
                    </React.Fragment>
                )
            }
            className="modal-dialog"
            overlayClassName="modal-overlay"
            shouldCloseOnOverlayClick={false}
        />
    );
}

PVQuantityChangedModal.propTypes = {
    message: PropTypes.string.isRequired,
    title: PropTypes.string,
    onRequestClose: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
};
PVQuantityChangedModal.defaultProps = {
    title: '',
};

export default PVQuantityChangedModal;
